import React from "react";
import QRcode from "../../images/qrcode.png";
import { Fade } from "react-awesome-reveal";
import "./style.css";
function ComponenrThird() {
  return (
    <div className="container maindiv22">
      <div className="row columndiv">
        <div className="col-lg-4 col-md-4 col-sm-12 mt-5 d-flex justify-content-center align-items-center flex-column mblview233245">
          <Fade direction="up" triggerOnce="true">
            <p className="fs-1 text-white text-start mb-5 textclass22">
              Time is precious
            </p>
            <p className="fs-3 text-white text-start textclass122">
              You can share any of your specific
              <br />
              profile details within few secconds
              <br />
              (5 secs) – it really is that fast!
            </p>
          </Fade>
        </div>
        <div className="col-lg-4 col-md-3 col-sm-12  d-flex justify-content-center align-items-center mblview2222">
          <img className="img-fluid mblview2211" src={QRcode} alt="" />
        </div>
      </div>
    </div>
  );
}

export default ComponenrThird;
